import { FC, ReactNode, useState } from 'react'
import { Button, Popconfirm, TriggerProps, Tooltip } from '@arco-design/web-react'
import Image from 'next/image'
import IconStarLight from '@/assets/ic_header_Star.png'
import IconStarDark from '@/assets/ic_star.png'
import styles from './index.module.less'
import useLocale from '@/utils/useLocale'
import useCollect from '@/hooks/useCollect'
import cx from 'classnames'
import { useUpdateEffect } from 'ahooks'
import type { CollectionGroupRes } from '@/types/api'
import CollectGroupDropdown from '@/components/CollectGroupDropdown'

type Props = Parameters<typeof useCollect>[0] & {
  id: string
  type: keyof CollectionGroupRes
}

export const CollectedButton: FC<{
  // 由于该按钮会作为 Dropdown 的 children，且 Dropdown 会注入 className，对按钮样式有影响，故将自定义的 prop 更名为 overrideClassName
  overrideClassName?: string
  icon?: ReactNode
  isLoading: boolean
  onClick: () => void
  triggerProps?: TriggerProps
}> = (props) => {
  const t = useLocale()
  const {
    overrideClassName = cx(styles.collectBtn, styles.collected),
    icon = <Image src={IconStarLight.src} width={16} height={14} alt="star" />,
    isLoading,
    onClick,
    triggerProps
  } = props

  return (
    <Popconfirm
      icon={null}
      className={styles.popConfirm}
      title={`${t['favorites.cancel.star']}?`}
      okText={t['favorites.cancel.star.yes']}
      cancelText={t['favorites.cancel.star.no']}
      okButtonProps={{
        className: styles.okButton
      }}
      cancelButtonProps={{
        className: styles.cancelButton
      }}
      onOk={onClick}
      triggerProps={triggerProps}
    >
      <Button loading={isLoading} className={overrideClassName} icon={icon} />
    </Popconfirm>
  )
}

const CollectButton: FC<Props> = (props) => {
  const { id, type, ...restProps } = props
  const { isCollected, isLoading, toggleCollect } = useCollect(restProps)
  const t = useLocale()
  useUpdateEffect(() => {
    if (isCollected) {
      setPopupVisible(true)
    }
  }, [isCollected])

  const [popupVisible, setPopupVisible] = useState(false)

  return (
    <CollectGroupDropdown
      id={id}
      type={type}
      popupVisible={popupVisible}
      onClose={() => {
        setPopupVisible(false)
      }}
    >
      {isCollected ? (
        <CollectedButton key="collected" onClick={toggleCollect} isLoading={isLoading} />
      ) : (
        <Tooltip content={t['collect']}>
          <Button
            key="collect"
            loading={isLoading}
            className={cx(styles.collectBtn, styles.collet)}
            icon={<Image src={IconStarDark.src} width={16} height={14} alt="star" />}
            onClick={isLoading ? undefined : toggleCollect}
          />
        </Tooltip>
      )}
    </CollectGroupDropdown>
  )
}

export default CollectButton
